module.exports = __webpack_public_path__ + "img/chart_widget_bar.cc83246.svg";